

export const onboardingAdminService = {
  async getAdminUser(userID: string) {
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_B2B_API_BASE_URL}/user/${userID}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch user:", error);
      throw error;
    }
  },
};
